import React, { Fragment, useContext, useState, useRef, useEffect } from 'react';
import { GlobalContext } from '../../context/Provider';
import henceforthApi from '../../utils/henceforthApi';
import Swal from 'sweetalert2';
import Spinner from '../common/spinner';
import { NumberValidation } from '../../utils/validations';
interface VerifyPickupOtpModalProps {
    show: boolean;
    handleClose: () => void;
    orderId: string;
    onVerifySuccess: () => void;
}

const VerifyPickupOtpModal: React.FC<VerifyPickupOtpModalProps> = ({ show, handleClose, orderId, onVerifySuccess }) => {
    const { language_data, authState } = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);
    const [otpErr, setOtpErr] = useState('');
    
    const [input, setInput] = useState({
        input1: "",
        input2: "",
        input3: "",
        input4: ""
    });

    const inputRef1 = useRef(null) as React.MutableRefObject<any>;
    const inputRef2 = useRef(null) as React.MutableRefObject<any>;
    const inputRef3 = useRef(null) as React.MutableRefObject<any>;
    const inputRef4 = useRef(null) as React.MutableRefObject<any>;

    const onInputChange1 = (evt: any) => {
        const value = evt.target.value;
        if (NumberValidation(value)) {
            setOtpErr('');
            setInput({ ...input, [evt.target.name]: value });
            if (value) inputRef2.current?.focus();
        }
    };

    const onInputChange2 = (evt: any) => {
        const value = evt.target.value;
        if (NumberValidation(value)) {
            setOtpErr('');
            setInput({ ...input, [evt.target.name]: value });
            if (value) inputRef3.current?.focus();
            else inputRef1.current?.focus();
        }
    };

    const onInputChange3 = (evt: any) => {
        const value = evt.target.value;
        if (NumberValidation(value)) {
            setOtpErr('');
            setInput({ ...input, [evt.target.name]: value });
            if (value) inputRef4.current?.focus();
            else inputRef2.current?.focus();
        }
    };

    const onInputChange4 = (evt: any) => {
        const value = evt.target.value;
        if (NumberValidation(value)) {
            setOtpErr('');
            setInput({ ...input, [evt.target.name]: value });
            if (!value) inputRef3.current?.focus();
        }
    };

    const handleVerifyOtp = async (e: any) => {
        e.preventDefault();
        const { input1, input2, input3, input4 } = input;
        const otpValue = `${input1}${input2}${input3}${input4}`;

        if (otpValue.length < 4) {
            setOtpErr('error');
            return Swal.fire({
                icon: 'warning',
                title: `${language_data?.[authState.lang]?.common_invalid_otp}`,
                text: `${language_data?.[authState.lang]?.common_please_enter_valid_otp}`,
                timer: 2000,
                showConfirmButton: false
            });
        }

        setLoading(true);
        try {
            const items = {
                _id: orderId,
                otp: otpValue,
                language: "ENGLISH"
            };
            
            await henceforthApi.Order.verifyPickupOtp(items);
            
            Swal.fire({
                icon: 'success',
                title: `${language_data?.[authState.lang]?.common_otp} ${language_data?.[authState.lang]?.common_verified}`,
                text: `${language_data?.[authState.lang]?.common_otp_verified_successfully}.`,
                timer: 2000,
                showConfirmButton: false
            }).then(() => {
                onVerifySuccess();
                handleClose();
                setInput({ input1: "", input2: "", input3: "", input4: "" });
                inputRef1.current?.focus();
            });
        } catch (err: any) {
            console.log(err?.response?.body?.error_description || err?.message || err);
            setInput({ input1: "", input2: "", input3: "", input4: "" });
            setOtpErr('error');
            inputRef1.current?.focus();
            Swal.fire({
                icon: 'error',
                title: `${language_data?.[authState.lang]?.common_invalid_otp}`,
                text: `${language_data?.[authState.lang]?.common_please_enter_valid_otp}`,
                timer: 2000,
                showConfirmButton: false
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Fragment>
            {show && (
                <div 
                    className="modal fade show" 
                    data-bs-backdrop="static" 
                    tabIndex={-1} 
                    role="dialog"
                    style={{ display: "block", backgroundColor: 'rgba(0,0,0,0.5)' }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="container">
                            <form className="row" onSubmit={handleVerifyOtp}>
                                <div className="col-md-8 m-auto">
                                    <div className="modal-content">
                                        <div className="modal-header border-0 p-0">
                                            <h5 className="w-100 text-center text-dark fw-bold fs-4 mt-2 d-flex justify-content-center" id="fixedPriceModalLabel">
                                                <span className="text-gradient">{language_data?.[authState.lang]?.common_verify_pickup_otp || 'Verify Pickup OTP'}</span>
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                style={{ position: 'absolute', right: '8px', top: '12px' }}
                                                onClick={handleClose}
                                                disabled={loading}
                                            ></button>
                                        </div>
                                        
                                        <div className="modal-body pt-1 pb-0 p-4">
                                            {/* Info Message */}
                                            <div className="alert alert-info d-flex align-items-start border-0 mb-3 px-3 py-2" style={{ backgroundColor: '#e7f3ff', borderRadius: '8px', fontSize: '13px' }} role="alert">
                                                <i className="fa fa-info-circle text-primary mt-1 me-2" style={{ fontSize: '16px' }}></i>
                                                <span>
                                                    Please enter the customer's OTP to confirm and complete the product delivery.
                                                </span>
                                            </div>

                                            <div className="position-relative mt-3">
                                                <div className="input-group">
                                                    <div className='form-fields-box d-flex gap-3 otp-verification-inputs justify-content-center mx-auto text-center'>
                                                        <input
                                                            type="text"
                                                            className={`text-center form-control rounded-0 ${otpErr ? 'border border-danger' : ''}`}
                                                            placeholder=""
                                                            tabIndex={1}
                                                            name='input1'
                                                            maxLength={1}
                                                            ref={inputRef1}
                                                            value={input.input1}
                                                            onChange={onInputChange1}
                                                            disabled={loading}
                                                            required />
                                                        <input
                                                            type="text"
                                                            className={`text-center form-control rounded-0 ${otpErr ? 'border border-danger' : ''}`}
                                                            ref={inputRef2}
                                                            tabIndex={2}
                                                            name='input2'
                                                            value={input.input2}
                                                            maxLength={1}
                                                            onChange={onInputChange2}
                                                            placeholder=""
                                                            disabled={loading}
                                                            required />
                                                        <input
                                                            type="text"
                                                            className={`text-center form-control rounded-0 ${otpErr ? 'border border-danger' : ''}`}
                                                            ref={inputRef3}
                                                            tabIndex={3}
                                                            name='input3'
                                                            value={input.input3}
                                                            maxLength={1}
                                                            onChange={onInputChange3}
                                                            placeholder=""
                                                            disabled={loading}
                                                            required />
                                                        <input
                                                            type="text"
                                                            className={`text-center form-control rounded-0 ${otpErr ? 'border border-danger' : ''}`}
                                                            ref={inputRef4}
                                                            tabIndex={4}
                                                            name='input4'
                                                            value={input.input4}
                                                            maxLength={1}
                                                            onChange={onInputChange4}
                                                            placeholder=""
                                                            disabled={loading}
                                                            required />
                                                    </div>
                                                </div>
                                                <p className="fs-10 text-dark mb-0 text-center mt-3">
                                                    {/* <i className="fa fa-mobile me-1"></i> */}
                                                    OTP has been sent to customer's registered mobile number
                                                </p>
                                            </div>
                                        </div>
                                        
                                        <div className="modal-footer border-0 pb-4 pt-2 p-4">
                                            <button type="submit" className="btn btn-theme shadow-none w-100 m-auto rounded-pill mb-2 text-capitalize" disabled={loading}>
                                                {loading ? <Spinner color="text-white" /> : `Verify Now`}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default VerifyPickupOtpModal;
